module.exports = __webpack_public_path__ + "img/TUNI_logo_grey.23c43cd4.svg";